module.exports = __webpack_public_path__ + "static/media/message_notification.3dec143f.mp3";